/**
 * Clerk appearance config - matches site color scheme from index.css
 * Applied to SignIn, SignUp, UserButton, and other Clerk components.
 */

/** Override "Sign in to Clerk" with Ministry Data Portal branding */
export const clerkLocalization = {
  signIn: {
    start: {
      title: 'Sign in to Ministry Data Portal',
      subtitle: 'Welcome back! Please sign in to continue',
    },
  },
  signUp: {
    start: {
      title: 'Create your account',
      subtitle: 'Welcome! Please fill in the details to get started.',
    },
  },
};

export const clerkAppearance = {
  variables: {
    colorPrimary: '#4b5563',
    colorPrimaryForeground: '#ffffff',
    colorForeground: '#374151',
    colorMutedForeground: '#4b5563',
    colorBackground: '#ffffff',
    colorInput: '#ffffff',
    colorInputForeground: '#374151',
    colorBorder: '#e5e5e5',
    colorNeutral: '#e5e5e5',
    colorMuted: '#f5f5f5',
    colorRing: '#4b5563',
    borderRadius: '0.5rem',
  },
  elements: {
    userButtonPopoverActionButton: 'text-[#374151]',
    userButtonPopoverActionButtonIcon: 'text-[#374151]',
  },
};
